/**
 * @fileoverview Popup Management System
 * @description Implements a comprehensive popup system with various trigger types and behaviors
 *
 * Features:
 * - Multiple trigger types: manual, time delay, exit intent, scroll position, accept agreement
 * - Age verification popups
 * - Cookie-based popup state management
 * - Customizable close behaviors (ESC, F4, overlay click)
 *
 * HTML Structure Required:
 * - Elements with class "popup" for popup containers
 * - Elements with class "popup-overlay" for overlay background
 * - Elements with class "popup-close" for close buttons
 * - Elements with class "popup-accept" for accept buttons
 * - Elements with class "age-verification__popup-close" for age verification close buttons
 * - Elements with class "age-verification__button-no" for age verification decline buttons
 */

'use strict';

jQuery(document).ready(function ($) {
  var adpPopup = {};

  (function () {
    var $this;

    adpPopup = {
      sPrevious: window.scrollY,
      sDirection: 'down',

      /**
       * @function init
       * @description Initializes the popup system
       * @param {Event} e - The event object
       */
      init: function (e) {
        $this = adpPopup;

        $this.popupInit(e);

        // Init events.
        $this.events(e);
      },

      /**
       * @function events
       * @description Sets up event listeners for popup interactions
       * @param {Event} e - The event object
       */
      events: function (e) {
        // Custom Events
        $(document).on('click', '.popup-close', $this.closePopup);
        $(document).on('click', '.popup-accept', $this.acceptPopup);
        $(document).on('click', '.popup-accept', $this.closePopup);
        $(document).on(
          'click',
          '.age-verification__popup-close',
          $this.agePopup
        );
        $(document).on(
          'click',
          '.age-verification__popup-close',
          $this.closePopup
        );
        $(document).on(
          'click',
          '.age-verification__button-no',
          $this.ageDeclined
        );

        // Checking this will cause popup to close when user presses key.
        $(document).keyup(function (e) {
          // Press ESC to Close.
          if (e.key === 'Escape') {
            $('.popup-open[data-esc-close="true"]').each(function (
              index,
              popup
            ) {
              $this.closePopup(popup);
            });
          }

          // Press F4 to Close.
          if (e.key === 'F4') {
            $('.popup-open[data-f4-close="true"]').each(function (
              index,
              popup
            ) {
              $this.closePopup(popup);
            });
          }
        });

        // Checking this will cause popup to close when user clicks on overlay.
        $(document).on('click', '.popup-overlay', function (e) {
          $('.popup-open[data-overlay-close="true"]').each(function (
            index,
            popup
          ) {
            $this.closePopup(popup);
            //$this.closePopup( $( this).prev() );
          });
        });
      },

      /**
       * @function popupInit
       * @description Initializes popup elements and sets up scroll tracking
       * @param {Event} e - The event object
       */
      popupInit: function (e) {
        // Set scroll direction.
        $(document).on('scroll', function () {
          let scrollCurrent = window.scrollY;

          // Set scroll temporary vars.
          if (scrollCurrent > $this.sPrevious) {
            $this.sDirection = 'down';
          } else {
            $this.sDirection = 'up';
          }

          $this.sPrevious = scrollCurrent;
        });

        // Open popup
        $('.popup').each(function (index, popup) {
          // Manual Launch.
          if ('manual' === $(popup).data('open-trigger')) {
            let selector = $(popup).data('open-manual-selector');

            if (selector) {
              $(selector).addClass('popup-trigger');

              $(document).on('click', selector, function (e) {
                e.preventDefault();

                $(popup).removeClass('popup-already-opened');

                $this.openPopup(popup);

                if (e.currentTarget.classList.contains('popup')) {
                  $this.closePopup(selector);
                }
              });
            }
          }

          // Checks whether a popup should be displayed or not.
          if (
            !$this.isAllowPopup(popup) &&
            !$(popup).hasClass('age-verification')
          ) {
            return;
          }

          $this.openTriggerPopup(popup);
        });
      },

      /**
       * @function openTriggerPopup
       * @description Handles popup opening based on trigger type
       * @param {Event|HTMLElement} e - The event object or popup element
       */
      openTriggerPopup: function (e) {
        let popup = e.originalEvent ? this : e;

        var trigger = $(popup).data('open-trigger');

        // Age Verification.
        if ('none' === trigger) {
          let ageVerification = $this.getCookie(
            'popup-age-' + $(popup).data('id') || 0
          );

          if (!ageVerification) $this.openPopup(popup);
        }

        // Time Delay.
        if ('delay' === trigger) {
          setTimeout(function () {
            $this.openPopup(popup);
          }, $(popup).data('open-delay-number') * 1000);
        }

        // Exit Intent.
        if ('exit' === trigger) {
          var showExit = true;
          document.addEventListener('mousemove', function (e) {
            // Get current scroll position
            var scroll =
              window.pageYOffset || document.documentElement.scrollTop;
            if (e.pageY - scroll < 7 && showExit) {
              $this.openPopup(popup);
              showExit = false;
            }
          });
        }

        // Scroll Position.
        if ('scroll' === trigger) {
          var pointScrollType = $(popup).data('open-scroll-type');
          var pointScrollPosition = $(popup).data('open-scroll-position');

          // Event scroll.
          $(document).on('scroll', function () {
            // Type px.
            if ('px' === pointScrollType) {
              if (window.scrollY >= pointScrollPosition) {
                $this.openPopup(popup);
              }
            }

            // Type %.
            if ('%' === pointScrollType) {
              if ($this.getScrollPercent() >= pointScrollPosition) {
                $this.openPopup(popup);
              }
            }
          });
        }

        // Accept Agreement.
        if ('accept' === trigger) {
          let accept = $this.getCookie(
            'popup-accept-' + $(popup).data('id') || 0
          );

          if (!accept) {
            $this.openPopup(popup);
          }
        }
      },

      /**
       * @function openPopup
       * @description Opens a popup and sets up its state
       * @param {HTMLElement} popup - The popup element to open
       */
      openPopup: function (e) {
        let popup = e.originalEvent ? this : e;

        // Hide body scroll.
        if ($(popup).is('[data-body-scroll-disable="true"]')) {
          $('body').addClass('popup-scroll-hidden');
        }

        // Set Cookie of Limit display.
        let limit =
          parseInt($this.getCookie('popup-' + $(popup).data('id')) || 0) + 1;

        $this.setCookie('popup-' + $(popup).data('id'), limit, {
          expires: $(popup).data('limit-lifetime'),
        });

        if ($(popup).hasClass('popup-open')) {
          return;
        }

        // Check already opened.
        if ($(popup).hasClass('popup-already-opened')) {
          return;
        }

        // Display popup.
        $(popup).addClass('popup-open');

        // Set current scroll.
        $(popup).data('init-scroll-px', window.scrollY);
        $(popup).data('init-scroll-percent', $this.getScrollPercent());

        // Open animation.
        let animation = $(popup).data('open-animation');

        $this.applyAnimation(popup, animation);

        // Init close trigger.
        $this.closeTriggerPopup(popup);
      },

      /**
       * @function closePopup
       * @description Closes a popup and cleans up its state
       * @param {HTMLElement} popup - The popup element to close
       */
      closePopup: function (e) {
        let $el = e.originalEvent ? this : e;

        // Get popup container.
        let popup = $($el).closest('.popup');

        // Close animation.
        let animation = $(popup).data('exit-animation');

        $this.applyAnimation(popup, animation, function () {
          // Already opened.
          $(popup).addClass('popup-already-opened');

          // Hide popup.
          $(popup).removeClass('popup-open');

          // Remove classes from body.
          $('body').removeClass('popup-scroll-hidden');
        });
      },

      /**
       * @function acceptPopup
       * @description Handles popup acceptance and sets cookies
       * @param {Event} e - The event object
       */
      acceptPopup: function (e) {
        let $el = e.originalEvent ? this : e;

        // Get popup container.
        let popup = $($el).closest('.popup');

        // Set Cookie of Accept.
        $this.setCookie('popup-accept-' + $(popup).data('id'), 1, {
          expires: 360,
        });
      },

      /**
       * @function agePopup
       * @description Handles age verification popup interactions
       * @param {Event} e - The event object
       */
      agePopup: function (e) {
        let $el = e.originalEvent ? this : e;

        // Get popup container.
        let popup = $($el).closest('.popup');

        // Set Cookie of Age.
        $this.setCookie('popup-age-' + $(popup).data('id'), 1, {
          expires: 360,
        });
      },

      /**
       * @function ageDeclined
       * @description Handles age verification decline action
       * @param {Event} e - The event object
       */
      ageDeclined: function () {
        $('.age-verification__question').removeClass('show');
        $('.age-verification__declined').addClass('show');
      },

      /**
       * @function isAllowPopup
       * @description Checks if a popup should be allowed to display
       * @param {HTMLElement} popup - The popup element to check
       * @returns {boolean} Whether the popup should be allowed
       */
      isAllowPopup: function (e) {
        let popup = e.originalEvent ? this : e;

        // Has user seen this popup before?
        let limitDisplay = parseInt($(popup).data('limit-display') || 0);

        let limitDisplayCookie = parseInt(
          $this.getCookie('popup-' + $(popup).data('id'))
        );

        if (
          limitDisplay &&
          limitDisplayCookie &&
          limitDisplayCookie >= limitDisplay
        ) {
          return;
        }

        return true;
      },

      /*
       * Apply animation
       */
      applyAnimation: function (el, name, callback) {
        var popup = $(el).closest('.popup');

        if (typeof callback === 'function') {
          var overlayName = 'popupExitFade';
        } else {
          var overlayName = 'popupOpenFade';
        }

        // Overlay Animation.
        $(popup)
          .next('.popup-overlay')
          .addClass('popup-animated ' + overlayName)
          .one(
            'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend',
            function () {
              $(this).removeClass('popup-animated ' + overlayName);
            }
          );

        // Wrap Animation.
        $(popup)
          .find('.popup-wrap')
          .addClass('popup-animated ' + name)
          .one(
            'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend',
            function () {
              // remove the animation classes after animation ends
              // required in order to apply new animation on close
              $(this).removeClass('popup-animated ' + name);

              if (typeof callback === 'function') {
                callback();
              }
            }
          );
      },

      /**
       * @function getCookie
       * @description Gets a cookie value by name
       * @param {string} name - The name of the cookie
       * @returns {string|null} The cookie value or null if not found
       */
      getCookie: function (name) {
        var matches = document.cookie.match(
          new RegExp(
            '(?:^|; )' +
              name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') +
              '=([^;]*)'
          )
        );
        return matches ? decodeURIComponent(matches[1]) : undefined;
      },

      /**
       * @function setCookie
       * @description Sets a cookie with the given name and value
       * @param {string} name - The name of the cookie
       * @param {string} value - The value to set
       * @param {number} days - The number of days until expiration
       */
      setCookie: function (name, value, options) {
        options = options || {};

        options.path = options.hasOwnProperty('path') ? options.path : '/';

        options.expires = parseInt(options.expires);

        if (typeof options.expires == 'number' && options.expires) {
          options.expires = new Date().setDate(
            new Date().getDate() + options.expires
          );

          options.expires = new Date(options.expires).toUTCString();
        }

        value = encodeURIComponent(value);

        var updatedCookie = name + '=' + value;

        for (var propName in options) {
          updatedCookie += '; ' + propName;
          var propValue = options[propName];
          if (propValue !== true) {
            updatedCookie += '=' + propValue;
          }
        }

        document.cookie = updatedCookie;
      },

      /**
       * @function getScrollPercent
       * @description Calculates the current scroll position as a percentage
       * @returns {number} The scroll percentage
       */
      getScrollPercent: function () {
        var h = document.documentElement,
          b = document.body,
          st = 'scrollTop',
          sh = 'scrollHeight';
        return ((h[st] || b[st]) / ((h[sh] || b[sh]) - h.clientHeight)) * 100;
      },
    };
  })();

  // Initialize.
  adpPopup.init();

  document.addEventListener('shopify:section:load', function () {
    adpPopup.init();
  });

  document.addEventListener('shopify:section:unload', function () {
    $('body').removeClass('popup-scroll-hidden');
  });
});
